import { render, staticRenderFns } from "./studentStatistics.vue?vue&type=template&id=51162778&scoped=true"
import script from "./studentStatistics.vue?vue&type=script&lang=js"
export * from "./studentStatistics.vue?vue&type=script&lang=js"
import style0 from "./studentStatistics.vue?vue&type=style&index=0&id=51162778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51162778",
  null
  
)

export default component.exports